<div class="certificate mx-auto">
    <strong [translate]="title"></strong>
    <h2 class="mat-display-1 text-blue font-weight-bold mb-0">
        {{ experience }}
    </h2>
</div>
